module.exports = __webpack_public_path__ + "../resources/img/ic_re_smartthings_guide_step1_img.5cc86bf1.svg";